import RdnaSmartTable from '@ringdna/common/src/components/RdnaTable/RdnaSmartTable'
import React, { useMemo, useState } from 'react'
import { Column } from 'react-table'
import { Location, SFUser } from '../../../../store/api/users-api'
import { COLUMN_WIDTH, getPaginationProps } from '../utils'
import NumberCell from './Cells/NumberCell'
import LocationCell from './Cells/LocationCell'
import RdnaText from '@ringdna/common/src/components/RdnaText'
import styled from 'styled-components'

type Props = {
  userList: SFUser[]
  setUserList: (list: SFUser[]) => void
  locations: Location[]
  assignAreaCode: boolean
  assignExtension: boolean
  assignLocation: boolean
}

export default function SmartNumbersAndLocation({
  userList,
  setUserList,
  locations,
  assignAreaCode,
  assignExtension,
  assignLocation
}: Props) {
  const [page, setPage] = useState(1)

  const columns = useMemo<Column<SFUser>[]>(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
        disableSortBy: true,
        width: COLUMN_WIDTH,
        Cell: (data: { value: string }) => <RdnaText className={'break-column'}>{data.value}</RdnaText>
      },
      {
        Header: 'Email',
        accessor: 'email',
        disableSortBy: true,
        width: COLUMN_WIDTH,
        Cell: (data: { value: string }) => <RdnaText className={'break-column'}>{data.value}</RdnaText>
      },
      {
        Header: 'Title',
        accessor: 'title',
        disableSortBy: true,
        width: COLUMN_WIDTH,
        Cell: (data: { value: string }) => <RdnaText className={'break-column'}>{data.value}</RdnaText>
      },
      {
        Header: 'Area Code',
        accessor: user => user,
        disableSortBy: true,
        width: COLUMN_WIDTH,
        Cell: function createdCell(data: { value: SFUser }) {
          return <NumberCell user={data.value} field={'areaCode'} disabled={assignAreaCode}></NumberCell>
        }
      },
      {
        Header: 'Extension',
        accessor: user => user,
        disableSortBy: true,
        width: COLUMN_WIDTH,
        Cell: function createdCell(data: { value: SFUser }) {
          return <NumberCell user={data.value} field={'extensionCode'} disabled={assignExtension}></NumberCell>
        }
      },
      {
        Header: 'Location',
        accessor: user => user,
        disableSortBy: true,
        width: COLUMN_WIDTH,
        Cell: function createdCell(data: { value: SFUser }) {
          return (
            <LocationCell
              user={data.value}
              disabled={assignLocation}
              userList={userList}
              setUserList={setUserList}
              locations={locations}
            ></LocationCell>
          )
        }
      }
    ],
    [assignAreaCode, assignExtension, assignLocation, locations, setUserList, userList]
  )

  return (
    <Container>
      <RdnaSmartTable
        columns={columns}
        data={userList.filter(user => user.dialerLicense)}
        onPagination={current => setPage(current)}
        initialTableState={{ pageIndex: page - 1 }}
        {...getPaginationProps(
          userList.filter(user => user.dialerLicense),
          userList.filter(user => user.dialerLicense).length
        )}
      />
    </Container>
  )
}

const Container = styled.div`
  [role='cell'] {
    height: auto;
  }
`
